import React from "react";
import useFirebaseFirings from "../hooks/useFirebaseFirings";
import _ from "lodash";

import FiringCard from "./FiringCard";

const FavouriteFiringsListPage = () => {
  const firings = useFirebaseFirings();
  if (!firings) {
    return <div>Loading...</div>;
  }

  const favourite_firings = _.filter(Object.values(firings), (firing: any) => !!firing.favourite);
  const favourite_firings_array =
    favourite_firings && Object.values(favourite_firings.map((a: any) => a));

  return (
    <div>
      <div>
        <h3 className="text-lg font-semibold mb-2">Favourite Firings</h3>
        {favourite_firings_array &&
          favourite_firings_array.map(
            (firing, index) =>
              firing && (
                <FiringCard
                  key={firing.id}
                  {...firing}
                  index={index}
                  to={`/firings/${firing.id}`}
                />
              )
          )}
      </div>
    </div>
  );
};

export default FavouriteFiringsListPage;
